<script setup lang="ts">
// Root shell. Routing does the work; this exists so <RouterView> has a host.
</script>

<template>
  <RouterView />
</template>
